<template>
  <div class="ms-form">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid">
        <CustomSelect
          :options="this.steps"
          label="Шаг"
          :required="true"
          :disabled="!!this.data?.lockStep"
          optionValueKey="step_id"
          optionLabelKey="step_name"
          :value="this.formData.step_id || ''"
          @change="(value) => onChange('step_id', value)"
        />
        <CustomInput
          label="Порядок"
          type="number"
          :value="this.formData.order_num"
          @change_input="(value) => onChange('order_num', value)"
        />
        <div class="ms-form-wide">
          <CustomSelect
            :options="this.gradeActions"
            label="Действие"
            :required="true"
            :disabled="this.isEdit"
            optionValueKey="activity_id"
            optionLabelKey="activity_name"
            :value="this.formData.activity_id || ''"
            @change="(value) => onChange('activity_id', value)"
          />
          <div v-if="this.selectedFuncName" class="activityFnInfo">
            <q-icon name="functions" size="16px" class="activityFnInfo__icon"/>
            <div class="activityFnInfo__body">
              <div class="activityFnInfo__row">
                Функция: <b>{{ this.selectedFuncName }}</b>
              </div>
              <div v-if="this.selectedFuncParams.length" class="activityFnInfo__params">
                Ожидаемые параметры:
                <span
                  v-for="(p, i) in this.selectedFuncParams"
                  :key="i"
                  class="activityFnInfo__param"
                >{{ p }}</span>
              </div>
              <div class="activityFnInfo__hint">
                Сама функция и её параметры меняются в «Таймлайн → Настройка событий → Действия».
              </div>
            </div>
          </div>
          <div v-if="this.isEdit" class="activityEditHint">
            При редактировании сменить действие нельзя. Чтобы заменить — удалите эту привязку и добавьте новую.
          </div>
        </div>
        <JsonEditor
          class="ms-form-wide"
          label="Параметры шага (json)"
          :hint="paramValueJsonHint"
          :rows="6"
          :value="this.formData.param_value_json"
          @change_input="(value) => onChange('param_value_json', value)"
        />
        <CustomSelect
          :options="this.grades"
          label="Грейды"
          optionValueKey="grade_id"
          optionLabelKey="grade_name"
          :value="this.formData.grade_ids || ''"
          @change="(value) => onChange('grade_ids', value)"
          :multiple="true"
        />
        <CustomInput
          label="Комментарии"
          type="text"
          :value="this.formData.comment"
          @change_input="(value) => onChange('comment', value)"
        />
        <div class="ms-form-wide activityActive">
          <CustomCheckbox
            label="Активный"
            :value="this.formData.is_active"
            @change="(value) => onChange('is_active', value)"
          />
        </div>
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import {getGradeActions} from "@/views/handbook/gradeTimelineActions/services";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import {getActivitySteps} from "@/views/handbook/stepActivity/services";
import { getGrades } from "@/views/timeline/services";
import JsonEditor from "@/components/form/JsonEditor";

export default {
  name: "add-step-activity",
  components: {CustomCheckbox, CustomSelect, CustomInput, CustomModalFooter, JsonEditor},
  props: ['data'],
  data() {
    return {
      loading: false,
      gradeActions: [],
      steps: [],
      grades: [],
      paramValueJsonHint:
        'Константные значения аргументов функции для этого шага.<br>' +
        '<b>param_N_value</b> — значение аргумента, <b>param_N_type</b> — его тип (varchar / integer / date / boolean).<br>' +
        'Если значение не задано — оно подставляется автоматически из контекста ремонта ' +
        '(client_request_id, remont_id, crm_deal_id…).<br>' +
        'Для действий типа «обновление поля таблицы» используются <b>param_value</b> и <b>param_type</b>.',
      formData: {
        step_id: this.data?.body?.step_id || '',
        activity_id: this.data?.body?.activity_id || '',
        comment: this.data?.body?.comment || '',
        grade_ids: this.data?.body?.grade_ids || [],
        order_num: this.data?.body?.order_num || '',
        param_value_json: this.data?.body?.param_value_json || '',
        is_active: !!this.data?.body?.is_active,
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.data?.body?.step_activity_id
    },
    selectedActivity() {
      return this.gradeActions.find(a => a.activity_id === this.formData.activity_id) || null
    },
    selectedActivityParamJson() {
      return this.parseJson(this.selectedActivity?.param_json)
    },
    selectedFuncName() {
      return this.selectedActivityParamJson?.func_name || ''
    },
    selectedFuncParams() {
      const pj = this.selectedActivityParamJson
      if (!pj) return []
      return Object.keys(pj)
        .filter(k => /^param_\d+$/.test(k))
        .sort((a, b) => Number(a.split('_')[1]) - Number(b.split('_')[1]))
        .map(k => pj[k])
    },
  },
  methods: {
    parseJson(val) {
      if (!val) return null
      if (typeof val === 'string') {
        try { return JSON.parse(val) } catch (e) { return null }
      }
      return val
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchGradeActions() {
      const res = await getGradeActions()
      this.gradeActions = res || []
    },
    async fetchSteps() {
      const res = await getActivitySteps()
      this.steps = res || []
    },
    async getGradesData() {
      const res = await getGrades()
      if(!res) return
      this.grades = res
    },
  },
  mounted() {
    this.fetchGradeActions()
    this.fetchSteps()
    this.getGradesData()
  }
}
</script>

<style scoped lang="scss">
.activityFnInfo {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  background: var(--ms-bg);
  border: 1px solid var(--ms-border);
  border-radius: var(--ms-radius-sm);
  font-size: 13px;
  color: var(--ms-text);

  &__icon {
    color: var(--ms-primary);
    margin-top: 1px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    word-break: break-word;
  }

  &__params {
    color: var(--ms-text-secondary);
    font-size: 12px;
  }

  &__param {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 6px;
    background: var(--ms-border);
    border-radius: 6px;
    font-family: monospace;
  }

  &__hint {
    margin-top: 2px;
    color: var(--ms-muted);
    font-size: 11px;
    font-style: italic;
  }
}

.activityEditHint {
  margin-top: 6px;
  padding: 6px 10px;
  background: var(--ms-warning-bg);
  border: 1px solid #fde68a;
  border-radius: var(--ms-radius-sm);
  color: var(--ms-warning);
  font-size: 12px;
}

.activityActive {
  margin: -4px 0 -4px -8px;
}
</style>
